import PropTypes from 'prop-types';
import React from 'react';
import shortId from 'shortid';
import asButton from '../decorator/asButton';
import withToolTip from '../decorator/withToolTip';
import './Button.css';
import IconComponent from './Icon';

const Button = React.memo(
  ({
    id,
    title,
    icon,
    toolTip,
    toolTipPosition,
    className,
    clickButtonEvent,
    clickButtonHandler,
    clickButtonArgs,
    children
  }) => (
    <button
      id={id}
      className={className}
      {...asButton(id, clickButtonEvent, clickButtonHandler, clickButtonArgs)}
      {...withToolTip(toolTip, toolTipPosition)}
      type="button">
      {icon && <IconComponent src={icon} caption="-" />}
      {title && <span>{title}</span>}
      {children && children}
    </button>
  )
);

Button.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  toolTip: PropTypes.string,
  toolTipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string,
  clickButtonEvent: PropTypes.string,
  clickButtonHandler: PropTypes.func,
  clickButtonArgs: PropTypes.any
};

Button.defaultProps = {
  id: `Button:${shortId.generate()}`,
  title: '',
  icon: undefined,
  toolTip: undefined,
  toolTipPosition: 'right',
  className: 'button',
  clickButtonEvent: undefined,
  clickButtonHandler: () => {},
  clickButtonArgs: undefined
};

export default Button;
